import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { Action, Module } from "types/generated";
import { AccessResult, NO_ACCESS_MESSAGE, hasAtLeastOneRequiredAction } from "utils/access";

const MARK_AS_BAD_ACCESS_TYPES = [Action.SpaceWrite, Action.ModuleMarkAsBad];

const useCanMarkModuleAsBad = (): ((module: Module) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (module: Module) => {
      if (viewer.admin) {
        return { result: true };
      }

      const spaceId = module.spaceDetails?.id || module.space;
      const result = hasAtLeastOneRequiredAction(MARK_AS_BAD_ACCESS_TYPES, viewer, spaceId);

      if (result) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanMarkModuleAsBad;
